import { fetchCache, DAY } from "../../utils/cache";

import type { EmojiItem } from "./types";

import type { FetchCustomEmojisQuery } from "~/client/generated/schema";
import { FetchCustomEmojisDocument } from "~/client/generated/schema";
import { client } from "~/client/utils/kibelaClient2";
import { kibelaContext } from "~/client/utils/kibelaContext";
import { ConnectionAllCount } from "~/client/utils/relay";

let data: ReadonlyArray<EmojiItem> = [];
// TODO: テストが通せるようにしneedFetchを外したい
const needFetch = process.env.NODE_ENV !== "test";
let state: "no-fetch" | "fetching" | "fetched" = "no-fetch";
const toCacheKey = (v: string) => `fetchCustomEmojis-${v}`;

const waitEmojiCache = async (): Promise<ReadonlyArray<EmojiItem>> => {
  const result = await new Promise<ReadonlyArray<EmojiItem>>((resolve) => {
    setTimeout(async () => {
      if (state === "fetched") {
        resolve(data);
      } else {
        resolve(waitEmojiCache());
      }
    }, 500);
  });
  return result;
};

export const fetchCustomEmojis = async () => {
  if (needFetch) {
    if (state === "fetched") {
      return data;
    }

    if (state === "fetching") {
      data = await waitEmojiCache();
      return data;
    }

    state = "fetching";
    data = await fetchCache(
      { key: toCacheKey(kibelaContext.customEmojisCacheKey!), expiresIn: 1 * DAY },
      async (updateCacheKey) => {
        const result = await client.query<FetchCustomEmojisQuery>({
          query: FetchCustomEmojisDocument,
          variables: { allCount: ConnectionAllCount },
        });

        if (!result.data) {
          throw "fetchCustomEmojis returns an error unexpectedly";
        }
        updateCacheKey(toCacheKey(result.data.customEmojisCacheKey));
        return result.data.customEmojis.nodes;
      },
    );
    state = "fetched";
    return data;
  }

  return data;
};

export const customEmojis = () => data;
